import React from 'react'
import ResultInput from './ResultInput'
import Heading from './Heading'

export default function YourFHC({R1,R2,R3,R4,R5,Slack}) {
  return (
    <div className="shadow-md p-6 bg-white space-y-7">
    <Heading text={"Your Financial Health Checkup "} icon={"checkup"} />
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-1 md:px-0 px-10 lg:grid-cols-2 gap-4 md:gap-y-8 lg:gap-x-20">

        <ResultInput label={"Debt / Income ratio"} value={isNaN(R1) || R1 === Infinity ? 0 : R1.toFixed(2) + '%'} tooltip={"How much of your income is spent on Debt Payments? Recommended < 20%"} />
        <ResultInput label={"Expense coverage ratio by savings"} value={isNaN(R2) || R2 === Infinity ? 0 : R2.toFixed(2) + '%'} tooltip={"How many times does your savings cover monthly expenses(expenses, debt and rent)? Recommended>300% (3 months)"} />
        <ResultInput label={"Assets / Liabilities"} value={isNaN(R3) || R3 === Infinity ? 0 : R3.toFixed(2) + '%'} tooltip={"Ratio of what you have vs what you owe. Recommended>100% (positive net worth)"} />
        <ResultInput label={"Assets / (Rent + Debt) coverage"} value={isNaN(R4) || R4 === Infinity ? 0 : R4.toFixed(2) + '%'} tooltip={"How many times can your obligations be covered by assets? Recommended > 1200% (one year) "} />
        <ResultInput label={"Housing cost ratio"} value={isNaN(R5) || R5 === Infinity ? 0 : R5.toFixed(2) + '%'} tooltip={"How much of your income is spent on housing costs? Recommended < 30% "} />
        <ResultInput label={"Slack in Budget"} value={isNaN(Slack) || Slack === Infinity || Number(Slack) < 0 ? 0 : '' + Slack.toFixed(0)} isLast  tooltip={"This is the surplus each month which can be used for goal planning"}/>
        {/* .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') */}
    </div>
</div>
  )
}
